<template>
	<v-row no-gutters>
		<v-col>
			<v-select
				:label="$localize('ArticleCalculation.attributes')"
				:items="attributeTypes"
				v-model="selectedAttributes"
				@input="$emit('input', selectedAttributes)"
				item-text="displayName"
				item-value="alias"
				multiple
				:hint="$localize('ArticleCalculation.attributes.hint')"
				:persistent-hint="true"
				prepend-icon="mdi-code-tags"
				:autofocus="autofocus"
				:loading="loading"
			/>
		</v-col>
		<v-col align-self="center" cols="auto" class="ml-1">
			<v-btn
				small
				outlined
				fab
				color="success"
				@click="createAttribute = true"
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</v-col>

		<create-attribute
			v-if="createAttribute"
			v-model="createAttribute"
			:attribute-type="false"
			:allow-continue="false"
			@saved="onSaved($event)"
		/>
	</v-row>
</template>

<script>
import CreateAttribute from '@/main/advanced/dialogs/CreateAttribute'

import { getAttributeTypes } from '@/services/api'
export default {
	components: { CreateAttribute },
	props: {
		value: {
			type: Array,
			required: true,
		},
		autofocus: Boolean,
	},
	data() {
		return {
			createAttribute: false,
			attributeTypes: [],
			selectedAttributes: this.value,
			loading: false,
		}
	},
	watch: {
		value(val) {
			this.selectedAttributes = val
		},
	},
	created() {
		this.refresh()
	},
	methods: {
		async refresh() {
			this.loading = true
			const { result, ok } = await getAttributeTypes.call()
			if (ok) {
				this.attributeTypes = result
			}
			this.loading = false
		},
		async onSaved(alias) {
			await this.refresh()
			this.selectedAttributes.push(alias)
		},
	},
}
</script>
